import classNames from 'classnames'
import i18next from 'i18next'
import {Dropdown} from 'primereact/dropdown'
import {Fieldset} from 'primereact/fieldset'
import {InputMask} from 'primereact/inputmask'
import {InputText} from 'primereact/inputtext'
import React from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import {PhoneTable} from './PhoneTable'
import i18n from '../../../../../i18n'
import {clothSize} from '../constants/clothSize.const'
import {confessions} from '../constants/confessions.const'
import {dominantHand} from '../constants/dominantHand.const'
import {driverLicense} from '../constants/driverLicense.const'
import {nativeLanguage} from '../constants/nativeLanguage.const'
import { travelCard } from '../constants/publicTransport.const'
import {salutations} from '../constants/salutations.const'
import {getBirthdate} from '../Helper'
import {ProfileFormProps} from '../interfaces/ProfileFormProps'

export const ProfileForm = (props: ProfileFormProps) => {
	const {control} = useFormContext()

	return (
		<>
			<Fieldset className={'m-2'} legend={i18n.t<string>('hrm.general')}>
				<div className=" p-fluid formgrid grid">
					<div className="field lg:col-4 col-12">
						<label htmlFor="salutation">
							{i18n.t<string>('person.salutation')}
						</label>
						<Controller
							name="salutation"
							control={control}
							render={({field, fieldState}) => <Dropdown
								options={salutations}
								placeholder={i18n.t<string>('Select your salutation')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="firstname">
							{i18n.t<string>('person.first_name')}
						</label>
						<Controller
							name="first_name"
							control={control}
							render={({field}) => <InputText
								placeholder={i18n.t<string>('person.first_name')}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="lastname">
							{i18n.t<string>('person.last_name')}
						</label>
						<Controller
							name="last_name"
							control={control}
							render={({field}) => <InputText
								placeholder={i18n.t<string>('person.last_name')}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
								{...field} />}/>
					</div>
					<div className="field lg:col-6 col-12">
						<label htmlFor="e-mail">
							{i18n.t<string>('person.email')}
						</label>
						<Controller
							name="email"
							control={control}
							render={({field, fieldState}) => <InputText
								placeholder={i18n.t<string>('example@mail.com')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-6 col-12">
						<label htmlFor="birthdate">
							{i18n.t<string>('person.birthdate')}
						</label>
						<Controller
							name="birthdate"
							control={control}
							render={({field}) => <InputText
								value={getBirthdate(field.value)}
								onChange={field.onChange}
								placeholder={i18n.t<string>('person.birthdate')}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}/>}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="city">
							{i18n.t<string>('person.city')}
						</label>
						<Controller
							name="city"
							control={control}
							render={({field, fieldState}) =>
								<InputText
									placeholder={i18n.t<string>('person.city')}
									className={classNames({'p-invalid': fieldState.error})}
									{...field}
									disabled
									tooltip={i18n.t<string>('core.no_permission')}
									tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
								/>
							}
						/>
					</div>
					<div className="field lg:col-2 col-12">
						<label htmlFor="plz">
							{i18n.t<string>('person.zip')}
						</label>
						<Controller
							name="postal_code"
							control={control}
							render={({field, fieldState}) => <InputText
								placeholder={i18n.t<string>('person.zip')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
							/>}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="street">
							{i18n.t<string>('person.street')}
						</label>
						<Controller
							name="street"
							control={control}
							render={({field, fieldState}) => <InputText
								placeholder={i18n.t<string>('person.street')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
							/>}/>
					</div>
					<div className="field lg:col-2 col-12">
						<label htmlFor="street_number">
							{i18n.t<string>('person.street_number')}
						</label>
						<Controller
							name="street_number"
							control={control}
							render={({field, fieldState}) => <InputText
								placeholder={i18n.t<string>('person.street_number')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
							/>}/>
					</div>
					<div className="field lg:col-6 col-12">
						<label htmlFor="company">
							{i18n.t<string>('core.company')}
						</label>
						<Controller
							name="company_name"
							control={control}
							render={({field}) => <InputText
								placeholder={i18n.t<string>('core.company')}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
								{...field} />}/>
					</div>
					<div className="field lg:col-6 col-12">
						<label htmlFor="phone">
							{i18n.t<string>('person.phone_list')}
						</label>
						<PhoneTable phoneNumbersToRemove={props.phoneNumbersToRemove}/>
					</div>
				</div>
			</Fieldset>
			<Fieldset className={'m-2'} legend={i18n.t<string>('hrm.advanced')}>
				<div className=" p-fluid formgrid  grid">
					<div className="field lg:col-6 col-12">
						<label htmlFor="bank">
							{i18n.t<string>('person.bank_name')}
						</label>
						<Controller
							name="bank_name"
							control={control}
							render={({field, fieldState}) => <InputText
								placeholder={i18n.t<string>('person.bank_name')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-6 col-12">
						<label htmlFor="insurance_number">
							{i18n.t<string>('person.health_insurance_number')}
						</label>
						<Controller
							name="health_insurance_number"
							control={control}
							render={({field}) => <InputText
								placeholder={i18n.t<string>('person.health_insurance_number')}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
								{...field}
								value={field.value ? field.value : ''}
							/>}
						/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="iban">
							{i18n.t<string>('person.iban')}
						</label>
						<Controller
							name="iban"
							control={control}
							render={({field, fieldState}) => <InputMask
								placeholder={i18n.t<string>('CH12 3456 7890 1234 5678 9')}
								mask="aa** **** **** **** **** *"
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="slack">
							{i18n.t<string>('person.slack_user_id')}
						</label>
						<Controller
							name="slack_user_id"
							control={control}
							render={({field, fieldState}) => <InputText
								placeholder={i18n.t<string>('person.slack_user_id')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="native_language">
							{i18n.t<string>('person.language')}
						</label>
						<Controller
							name="id_first_language"
							control={control}
							render={({field, fieldState}) => <Dropdown
								options={nativeLanguage}
								placeholder={i18n.t<string>('language.help.choose_language')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="workload">
							{i18n.t<string>('person.workload_in_percent')}
						</label>
						<Controller
							name="workload_in_percent"
							control={control}
							render={({field}) => <InputText
								placeholder={i18n.t<string>('person.workload_in_percent')}
								disabled
								tooltip={i18n.t<string>('core.no_permission')}
								tooltipOptions={{showOnDisabled: true, position: 'bottom', showDelay: 1000}}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="confession">
							{i18n.t<string>('person.confession')}
						</label>
						<Controller
							name="confession"
							control={control}
							render={({field, fieldState}) => <Dropdown
								options={confessions}
								placeholder={i18next.t<string>('hrm.confession.help.choose_confession')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="cloth_size">
							{i18n.t<string>('person.cloth_size')}
						</label>
						<Controller
							name="cloth_size"
							control={control}
							render={({field, fieldState}) => <Dropdown
								options={clothSize}
								placeholder={i18n.t<string>('core.choose')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="dominant_hand">
							{i18n.t<string>('person.dominant_hand')}
						</label>
						<Controller
							name="dominant_hand"
							control={control}
							render={({field, fieldState}) => <Dropdown
								options={dominantHand}
								placeholder={i18n.t<string>('dominant_hand.help.choose_dominant_hand')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
						<label htmlFor="vehicle_license">
							{i18n.t<string>('person.vehicle_license')}
						</label>
						<Controller
							name="vehicle_license"
							control={control}
							render={({field, fieldState}) => <Dropdown
								options={driverLicense}
								placeholder={i18n.t<string>('core.choose')}
								className={classNames({'p-invalid': fieldState.error})}
								{...field} />}/>
					</div>
					<div className="field lg:col-4 col-12">
				<label htmlFor="travel_card">
					{i18n.t<string>('person.public_transport.title')}
				</label>
				<Controller
					name="travel_card"
					control={control}
					render={({field, fieldState}) => <Dropdown
						options={travelCard}
						editable
						maxLength={40}
						placeholder={i18n.t<string>('core.choose')}
						className={classNames({'p-invalid': fieldState.error})}
						{...field} />}/>
			</div>
				</div>
			</Fieldset>
		</>
	)
}
